import React from 'react';
import { Avatar, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import DynamicIcon from '../Complements/DynamicIcon';
import { filterArrayEqual } from '../../functions/arrays';
import { useSelector } from 'react-redux';

const ShowValidatorsActivities = props => {
    const {dataValidators} = props
    const states = useSelector((state) => {
        console.log(state);
        
        return state.states
    });
    console.log(states);
    
    // const user = useSelector((state) => state.user);
    return (
        <div>
            <List>
                {
                    dataValidators.map(dv => {
                        const {body} = dv
                        const bdy = JSON.parse(body)
                        // console.log(filterArrayEqual(states, 'id', dv.state))
                        return <ListItem button onClick={() => console.log('clic')}>
                                    <ListItemAvatar>
                                        <Avatar>{'$'}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        style={{maxWidth: '70%'}}
                                        primary={<span>{`${bdy.Name !== '' ? bdy.Name : bdy.FirstName + ' ' + bdy.LastName}`}</span>}
                                        secondary={<span>{`Observación: ${dv.observation}`}</span>}
                                    />
                                    <ListItemSecondaryAction>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 10px', backgroundColor: filterArrayEqual(states, 'id', dv.state)[0].color, borderRadius: '20px' }}>
                                            <span>{filterArrayEqual(states, 'id', dv.state)[0].name}</span>
                                        <DynamicIcon iconName={filterArrayEqual(states, 'id', dv.state)[0].icon} />
                                        </div>
                                    </ListItemSecondaryAction>
                                </ListItem>
                    })
                }
                
            </List>
        </div>
    );
};

ShowValidatorsActivities.propTypes = {
    
};

export default ShowValidatorsActivities;